import * as _ from 'underscore';
import { L10n } from '../L10n/L10n';
import { ConfirmDialogInputNumberScope } from '../models/ConfirmDialogInputNumberScope';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { AbstractContentAction } from '../../commonInfra/contentActions/AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import {
  simpleActionErrorMsg,
  simpleActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { Formatters, Messages } from '../../codegen/Localize';

export class ChangeRunFlowTasksPriorityAction extends AbstractContentAction<RunFlowTaskInfo> {

  public static $inject = [
    'ConfirmActionDialog',
  ];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
  ) {
    super(ConfirmActionDialog);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, runFlowTaskInfos: Set<RunFlowTaskInfo>) {

    const scope = <ConfirmDialogInputNumberScope> dialogConfig.scope;

    if(runFlowTaskInfos.size() === 1) {
      const task = runFlowTaskInfos.first();
      scope.description = Messages.runFlowTasksSetPriorityPrompt({
        FLOW_NAME: L10n.elideIfLong(task.flow.name)
      });
    } else {
      scope.description = Messages.runFlowTasksSetPriorityMultiplePrompt({
        ITEM_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size()),
      });
    }

    scope.numberDescription = Messages.createScheduleFormPriorityDescription();

    scope.input = {
      num: Math.min(..._.map(runFlowTaskInfos.toArray(), (tasks: RunFlowTaskInfo) => tasks.priority)),
      min: RunFlowTasks.MIN_PRIORITY,
      max: RunFlowTasks.MAX_PRIORITY,
      isInteger: true,
      width: '75px'
    };

    dialogConfig.bodyTemplateUrl = 'confirmActionDialogInputNumber.html';
    dialogConfig.title = Messages.tasksSetPriority();
    dialogConfig.actionName = Messages.tasksSetPriorityConfirm({
      ITEM_COUNT: runFlowTaskInfos.size(),
      ITEM_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size()),
    });
    dialogConfig.action = () => RunFlowTasks.setPriority(runFlowTaskInfos.keys(), scope.input.num);
  }

  notificationTranslationFns() {
    return {
      successMsg: simpleActionSuccessMsg(Messages.runFlowTasksSetPrioritySuccess),
      errorMsg: simpleActionErrorMsg(Messages.runFlowTasksSetPriorityError),
    };
  }

}

Module.instance().service('ChangeRunFlowTasksPriorityAction', ChangeRunFlowTasksPriorityAction);
